module.exports = __webpack_public_path__ + "img/step3_a_locate components.d2b66e6c.png";